// golf 7.5 i par
import golf751 from '../assets/cars/golf7.51/golf7.5ibardh(1).webp'
import golf752 from '../assets/cars/golf7.51/golf7.5ibardh(2).webp'
import golf753 from '../assets/cars/golf7.51/golf7.5ibardh(3).webp'
import golf754 from '../assets/cars/golf7.51/golf7.5ibardh(4).webp'
// ---------------------------------------------------------

// golf 8 i par

import golf81 from '../assets/cars/golf81/image00001.webp';
import golf82 from '../assets/cars/golf81/image00002.webp';
import golf83 from '../assets/cars/golf81/image00003.webp';
import golf84 from '../assets/cars/golf81/image00004.webp';
import golf85 from '../assets/cars/golf81/image00005.webp';

// ---------------------------------------------------------------

// passati 1

import passati1 from '../assets/cars/passati1/image00001.webp';
import passati2 from '../assets/cars/passati1/image00002.webp';
import passati3 from '../assets/cars/passati1/image00003.webp';
import passati4 from '../assets/cars/passati1/image00004.webp';

// ---------------------------------------------------------------

// golf 7.52

import golf7521 from '../assets/cars/golf7.52/image00001.webp';
import golf7522 from '../assets/cars/golf7.52/image00002.webp';
import golf7523 from '../assets/cars/golf7.52/image00003.webp';
import golf7524 from '../assets/cars/golf7.52/image00004.webp';
import golf7525 from '../assets/cars/golf7.52/image00005.webp';

// ---------------------------------------------------------------


//audi a3 1

import audia31 from '../assets/cars/audia31/image00001.webp';
import audia32 from '../assets/cars/audia31/image00002.webp';
import audia33 from '../assets/cars/audia31/image00003.webp';
import audia34 from '../assets/cars/audia31/image00004.webp';
import audia35 from '../assets/cars/audia31/image00005.webp';

// ---------------------------------------------------------------


export const cars = [
  {
    id: 1,
    name: 'Volkswagen Golf 7.5',
    category: 'Ekonomike',
    year: 2020,
    seats: 5,
    transmission: 'Automatike',
    fuel: 'Naftë',
    engine: '1.6 TDI',
    image: golf752,
    available: true,
    description: 'Eksperiencë premium me kosto ekonomike. Golf 7.5 kombinon teknologjinë me komoditetin maksimal, i pajisur me drita LED IQ dhe sistemin më modern të asistencës për vozitje pa stres.',
    features: ['Bluetooth', 'Kamera prapa', 'Ngrohje ulëseve', 'GPS', 'USB-C', 'Drita Robotike', 'Led IQ', 'Distronic (ACC)'],
    photos: [golf753, golf754, golf751],
  },
  {
    id: 2,
    name: 'Volkswagen Golf 8',
    category: 'Ekonomike',
    year: 2023,
    seats: 5,
    transmission: 'Automatike',
    fuel: 'Naftë',
    engine: '2.0 TDI',
    image: golf84,
    available: true,
    description: 'E ardhmja e vozitjes është këtu. Golf 8 sjell një interier tërësisht digjital dhe performancë superiore me motorin 2.0 TDI. E pajisur me teknologjinë më të fundit të sigurisë dhe dritat inteligjente LED Matrix për një udhëtim pa kompromise.',
    features: [
      'Digital Cockpit', 
      'Wireless Apple CarPlay/Android Auto', 
      'Ambient Lighting (30 ngjyra)', 
      'Kamera 360', 
      'Lane Assist', 
      'Travel Assist', 
      'Led IQ.Light Matrix', 
      'Park Assist'
    ],
    photos: [golf83, golf82, golf81, golf85],
},

{
    id: 3,
    name: 'Passat B8 HighLine',
    category: 'Premium / Business', 
    year: 2018,
    seats: 5,
    transmission: 'Automatike',
    fuel: 'Naftë',
    engine: '2.0 TDI',
    image: passati1,
    available: true,
    description: 'Simboli i elegancës dhe komoditetit. Passat B8 HighLine ofron hapësirë maksimale dhe një udhëtim "Business Class". I pajisur me interier luksoz, karrige me masazh dhe teknologji të avancuar, është zgjedhja perfekte për udhëtime të gjata dhe prezantim dinjitoz.',
    features: [
      'Interier Alcantara / Lëkurë', 
      'Karrige ErgoComfort me Masazh', 
      'Navigacion Discovery Pro', 
      'Distronic (ACC)', 
      'Park Pilot', 
      'Drita LED High', 
      'Auto Hold'
    ],
    photos: [passati2, passati3, passati4],
},
{
    id: 4,
    name: 'Volkswagen Golf 7.5',
    category: 'Ekonomike', 
    year: 2019,
    seats: 5,
    transmission: 'Automatike',
    fuel: 'Naftë',
    engine: '1.6 TDI',
    image: golf7521,
    available: true,
    description: 'Ekuilibri perfekt mes ekonomisë dhe teknologjisë. Golf 7.5 i vitit 2019 me motorin 1.6 TDI ofron konsum minimal karburanti pa sakrifikuar komoditetin. Ideale për lëvizje dinamike në qytet dhe udhëtime ekonomike në distanca të gjata.',
    features: [
      'App-Connect (CarPlay/Android Auto)', 
      'Front Assist (Vozitje e Sigurt)', 
      'Park Sensor (Para/Mbrapa)', 
      'Cruise Control', 
      'Klimë Automatike Dy-Zonale', 
      'Touchscreen Infotainment', 
      'Auto Hold',
      'Start/Stop System'
    ],
    photos: [golf7522, golf7523, golf7524, golf7525],
},

{
    id: 5,
    name: 'Audi A3',
    category: 'Premium', 
    year: 2017,
    seats: 5,
    transmission: 'Automatike',
    fuel: 'Naftë',
    engine: '2.0 TDI',
    image: audia31,
    available: true,
    description: 'Stil dhe performancë në çdo detaj. Audi A3 ofron një eksperiencë vozitjeje superiore me motorin e fuqishëm 2.0 TDI dhe interierin e rafinuar. Kombinimi perfekt i elegancës gjermane me teknologjinë moderne për ata që kërkojnë diçka më shumë se një makinë e thjeshtë.',
    features: [
      'S-Line Interior (Opsionale)', 
      'Audi Drive Select (Mode Vozitjeje)', 
      'MMI Navigation Plus', 
      'Drita Xenon/LED Plus', 
      'Sistemi i zërimit Premium', 
      'Bluetooth & Multimedia', 
      'Sensorë Parkimi Gjerësisht', 
      'Timon Sportiv me lëkurë'
    ],
    photos: [audia32, audia33, audia34, audia35],
},
];

export const categories = ['Të gjitha', ...new Set(cars.map(c => c.category))];